/**
 * @hidden
 */
export var isFilterable = function (settings) { return settings !== false; };
/**
 * @hidden
 */
export var hasFilterMenu = function (settings) {
    return typeof settings === 'string' && settings.indexOf('menu') > -1;
};
/**
 * @hidden
 */
export var hasFilterRow = function (settings) {
    return settings === true || (typeof settings === 'string' && settings.indexOf('row') > -1);
};



//////////////////
// WEBPACK FOOTER
// C:/spro/Workspaces/VisualCode/Ecoltex2/node_modules/@progress/kendo-angular-grid/dist/es/filtering/filterable.js
// module id = ../../../../@progress/kendo-angular-grid/dist/es/filtering/filterable.js
// module chunks = vendor